import { createFileRoute, Outlet } from "@tanstack/react-router";
import { redirectIfModuleDisabled } from "@/lib/module-guards";

export const Route = createFileRoute("/_authorized/team/billing")({
	beforeLoad: () => redirectIfModuleDisabled("billing"),
	component: () => <Outlet />,
});
